import { getDeviceAndWifiInfo, fetcher, getSession, aeigs, checkLogin } from '../lib';

const reqParamsInit = async (env, businessInfo) => {
  const deviceInfo = await getDeviceAndWifiInfo();
  const reqParams = {
    device: {
      app_type: businessInfo.app_type || 0,
      ip: deviceInfo.ip || '',
      app_version: deviceInfo.app_version,
      terminal_type: deviceInfo.terminal_type,
      terminal_id: deviceInfo.id || '',
      guid: deviceInfo.guid || '',
      qua: deviceInfo.qua2 || '',
      ext: {
        imei: deviceInfo.imei || '',
        qimei: deviceInfo.qimei || '',
        mac_addr: deviceInfo.macAddress || '',
        phone_type: deviceInfo.phone_type,
        manufacturer: deviceInfo.brand || '',
        phone_name: deviceInfo.brand || '',
        idfa: deviceInfo.advertisingIdentifier || '',
        idfv: deviceInfo.idfv || '',
        android_id: deviceInfo.android_id || '',
        wifi_mac: deviceInfo.wifi_mac || '',
        imsi: deviceInfo.imsi || '',
        os_version: deviceInfo.os_version || '',
        wifi_ssid: deviceInfo.ssid || '',
        turingtonID: deviceInfo.turingTicket || '',
      },
    },
    certification: {
      app_id: businessInfo.app_id || '',
      timestamp: Math.floor(Date.now() / 1000),
    },
  };
  const isLogin = await checkLogin();
  if (isLogin) {
    // 有登录态
    const userSession = await getSession(env);
    reqParams.user = {
      session: {
        session_key: userSession.sk,
        session_auth: userSession.sa,
      },
    };
  }
  return reqParams;
};

export const qqkdFollow = (userList, businessInfo, env = 'real') => new Promise(async (resolve, reject) => {
  try {
    aeigs.infoAll({
      location: 'qqkdFollow function start',
      userList,
      businessInfo,
      env,
    });
    const reqParams = await reqParamsInit(env, businessInfo);
    reqParams.user2_list = userList;
    const res = await fetcher('kdFollow', reqParams, env);
    resolve(res);
    return res;
  } catch (error) {
    reject({
      code: -1,
      error,
    });
  }
});

export const qqkdUnFollow = (user, businessInfo, env = 'real') => new Promise(async (resolve, reject) => {
  try {
    aeigs.infoAll({
      location: 'qqkdUnFollow function start',
      user,
      businessInfo,
      env,
    });
    const reqParams = await reqParamsInit(env, businessInfo);
    reqParams.user2 = user;
    const res = await fetcher('kdUnFollow', reqParams, env);
    resolve(res);
    return res;
  } catch (error) {
    reject({
      code: -1,
      error,
    });
  }
});

export const qqkdQueryFollowStatus = (userList, businessInfo, env = 'real') => new Promise(async (resolve, reject) => {
  try {
    aeigs.infoAll({
      location: 'qqkdQueryFollowStatus function start',
      userList,
      businessInfo,
      env,
    });
    const reqParams = await reqParamsInit(env, businessInfo);
    reqParams.user_list = userList;
    const res = await fetcher('kdQueryFollowStatus', reqParams, env);
    resolve(res);
    return res;
  } catch (error) {
    reject({
      code: -1,
      error,
    });
  }
});
